import { DiagnosticsYearFilters } from '../../widgets/diagnosticsYearFilters';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';

// Страница для отображения фильтров панорамы
export function YearFilterPage() {
    const containsMap = window.location.pathname.includes('map');
    const containsGroupingsMap = window.location.pathname.includes('group');
    const containsGroupingsDiagnostics = window.location.pathname.includes('diagnosticsMeasureResults');
    const containsRoadAccidentSegments = window.location.pathname.includes('RoadAccidentSegments');
    const containsPathNormativities = window.location.pathname.includes('PathNormativities');


    const pathNormativitiesInfo = window.location.pathname.includes('diagnostics/pathNormativities');
    return (
        <>
            <ContentHeader title="Настройка фильтров" />
            {pathNormativitiesInfo && <DiagnosticsYearFilters type="page" filterType="PathNormativitiesInfo" />}
            {containsGroupingsMap && <DiagnosticsYearFilters type="page" filterType="PathNormativitiesMapMeasureTypesGroup" />}
            {containsMap && containsPathNormativities && !containsGroupingsMap && <DiagnosticsYearFilters type="page" filterType="PathNormativitiesMapMeasureType" />}
            {containsGroupingsDiagnostics && <DiagnosticsYearFilters type="page" filterType="RoadMeasureResults" />}
            {containsRoadAccidentSegments && <DiagnosticsYearFilters type="page" filterType="RoadAccidentSegmentsMap" />}
        </>
    );
}
